module.exports = __webpack_public_path__ + "static/media/landeslease.4b5b9a85.png";